import { render, staticRenderFns } from "./mobile-header.vue?vue&type=template&id=99485aba&scoped=true&lang=pug&"
import script from "./mobile-header.vue?vue&type=script&lang=js&"
export * from "./mobile-header.vue?vue&type=script&lang=js&"
import style0 from "./mobile-header.vue?vue&type=style&index=0&id=99485aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99485aba",
  null
  
)

export default component.exports